export type NoteHistoryKeyPress = Pick<
  KeyboardEvent,
  'key' | 'metaKey' | 'ctrlKey' | 'shiftKey' | 'altKey'
>;

// Cmd/Ctrl+Z undoes a document's latest step, Cmd/Ctrl+Shift+Z and Ctrl+Y
// redo it, on every platform.
export const readNoteHistoryKey = ({
  key,
  metaKey,
  ctrlKey,
  shiftKey,
  altKey,
}: NoteHistoryKeyPress): 'undo' | 'redo' | null => {
  if (altKey || !(metaKey || ctrlKey)) {
    return null;
  }
  const pressed = key.toLowerCase();
  if (pressed === 'z') {
    return shiftKey ? 'redo' : 'undo';
  }
  return pressed === 'y' && ctrlKey && !shiftKey ? 'redo' : null;
};
